var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.pending_orders.orders.length)?[_vm._l((_setup.pending_orders.orders),function(item){return [_c(_setup.Notification,{key:item.nmbr,attrs:{"item":item,"params":_setup.pending_orders.params}})]})]:[_c(_setup.EmptyState,{attrs:{"icon":"mdi-bell-check-outline","label":"Нет новых уведомлений"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }